import { render, staticRenderFns } from "./ConfirmDeletion.vue?vue&type=template&id=fa0965a8&scoped=true"
import script from "./ConfirmDeletion.vue?vue&type=script&lang=js"
export * from "./ConfirmDeletion.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeletion.vue?vue&type=style&index=0&id=fa0965a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0965a8",
  null
  
)

export default component.exports